import React from "react";
import Modal1 from "../../../../../components/DIsplay/Modal/Modal1";
import TicketIssue from "../../../../Orders/IssueTicket";

function ManageOrderIssueTicketModal({ booking, modal, setModal }) {
  return (
    <div>
      <Modal1
        open={modal.issue}
        setOpen={(modalState) =>
          setModal((prev) => ({ ...prev, issue: modalState }))
        }
      >
        <TicketIssue
          data={booking}
          callback={() => {
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }}
          close={() => setModal((prev) => ({ ...prev, issue: false }))}
        />
      </Modal1>
    </div>
  );
}

export default ManageOrderIssueTicketModal;
